{
  "version_info": {
    "major": 2026,
    "minor": 18,
   "git_hash" : "193669e3"
  }
}
